export const AVATAR_MENTION_COLOR_MAP = {
    'bg-slate-600': 'bg-slate-600/15 dark:bg-slate-400/20 text-slate-600 dark:text-slate-400',
    'bg-red-600': 'bg-red-600/15 dark:bg-red-400/20 text-red-600 dark:text-red-400',
    'bg-orange-600': 'bg-orange-600/15 dark:bg-orange-400/20 text-orange-600 dark:text-orange-400',
    'bg-amber-600': 'bg-amber-600/15 dark:bg-amber-400/20 text-amber-600 dark:text-amber-400',
    'bg-yellow-600': 'bg-yellow-600/15 dark:bg-yellow-400/20 text-yellow-600 dark:text-yellow-400',
    'bg-lime-600': 'bg-lime-600/15 dark:bg-lime-400/20 text-lime-600 dark:text-lime-400',
    'bg-green-600': 'bg-green-600/15 dark:bg-green-400/20 text-green-600 dark:text-green-400',
    'bg-emerald-600': 'bg-emerald-600/15 dark:bg-emerald-400/20 text-emerald-600 dark:text-emerald-400',
    'bg-teal-600': 'bg-teal-600/15 dark:bg-teal-400/20 text-teal-600 dark:text-teal-400',
    'bg-cyan-600': 'bg-cyan-600/15 dark:bg-cyan-400/20 text-cyan-600 dark:text-cyan-400',
    'bg-blue-600': 'bg-blue-600/15 dark:bg-blue-400/20 text-blue-600 dark:text-blue-400',
    'bg-indigo-600': 'bg-indigo-600/15 dark:bg-indigo-400/20 text-indigo-600 dark:text-indigo-400',
    'bg-violet-600': 'bg-violet-600/15 dark:bg-violet-400/20 text-violet-600 dark:text-violet-400',
    'bg-purple-600': 'bg-purple-600/15 dark:bg-purple-400/20 text-purple-600 dark:text-purple-400',
    'bg-fuchsia-600': 'bg-fuchsia-600/15 dark:bg-fuchsia-400/20 text-fuchsia-600 dark:text-fuchsia-400',
    'bg-pink-600': 'bg-pink-600/15 dark:bg-pink-400/20 text-pink-600 dark:text-pink-400',
    'bg-neutral-600': 'bg-neutral-600/15 dark:bg-neutral-400/20 text-neutral-600 dark:text-neutral-400' // Default fallback
};

export const LABEL_COLOR_MAP = {
    'gray': 'bg-neutral-500',
    'red': 'bg-red-500',
    'yellow': 'bg-yellow-500',
    'green': 'bg-green-500',
    'blue': 'bg-blue-500',
    'purple': 'bg-purple-500',
    'violet': 'bg-violet-500',
    'pink': 'bg-pink-500',
    'emerald': 'bg-emerald-500',
    'cyan': 'bg-cyan-500'
};

export const STATUS_COLORS = {
    'gray': {
        text: 'text-neutral-500',
        bg: 'bg-neutral-500'
    },
    'red': {
        text: 'text-red-500',
        bg: 'bg-red-500'
    },
    'yellow': {
        text: 'text-yellow-500',
        bg: 'bg-yellow-500'
    },
    'green': {
        text: 'text-green-500',
        bg: 'bg-green-500'
    },
    'blue': {
        text: 'text-blue-500',
        bg: 'bg-blue-500'
    },
    'purple': {
        text: 'text-purple-500',
        bg: 'bg-purple-500'
    },
    'violet': {
        text: 'text-violet-500',
        bg: 'bg-violet-500'
    },
    'pink': {
        text: 'text-pink-500',
        bg: 'bg-pink-500'
    },
    'emerald': {
        text: 'text-emerald-500',
        bg: 'bg-emerald-500'
    },
    'cyan': {
        text: 'text-cyan-500',
        bg: 'bg-cyan-500'
    }
};

export const RELEASE_STATUS_COLORS = {
    upcoming: {
        text: 'text-neutral-600 dark:text-neutral-400',
        icon: 'text-neutral-500',
        bg: 'bg-neutral-100 dark:bg-neutral-900/20',
        border: 'border border-neutral-300 dark:border-neutral-700',
        hover: 'hover:bg-neutral-200 dark:hover:bg-neutral-900/30'
    },
    active: {
        text: 'text-blue-600 dark:text-blue-400',
        icon: 'text-blue-500',
        bg: 'bg-blue-100 dark:bg-blue-900/20',
        border: 'border border-blue-300 dark:border-blue-700',
        hover: 'hover:bg-blue-200 dark:hover:bg-blue-900/30'
    },
    overdue: {
        text: 'text-red-600 dark:text-red-400',
        icon: 'text-red-500',
        bg: 'bg-red-100 dark:bg-red-900/20',
        border: 'border border-red-300 dark:border-red-700',
        hover: 'hover:bg-red-200 dark:hover:bg-red-900/30'
    },
    shipped: {
        text: 'text-emerald-600 dark:text-emerald-400',
        icon: 'text-emerald-500',
        bg: 'bg-emerald-100 dark:bg-emerald-900/20',
        border: 'border border-emerald-300 dark:border-emerald-700',
        hover: 'hover:bg-emerald-200 dark:hover:bg-emerald-900/30'
    }
};

export const getReleaseStatusColor = (status) => {
    return RELEASE_STATUS_COLORS[status] || RELEASE_STATUS_COLORS.upcoming;
};

// Button active state colors (for filters, toggles, etc.)
export const BUTTON_ACTIVE_COLOR_MAP = {
    'bg-slate-600': {
        button: 'border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-950/50 dark:text-slate-300',
        indicator: 'text-slate-600 dark:text-slate-400',
        dot: 'bg-slate-600'
    },
    'bg-red-600': {
        button: 'border-red-300 bg-red-50 text-red-700 dark:border-red-700 dark:bg-red-950/50 dark:text-red-300',
        indicator: 'text-red-600 dark:text-red-400',
        dot: 'bg-red-600'
    },
    'bg-orange-600': {
        button: 'border-orange-300 bg-orange-50 text-orange-700 dark:border-orange-700 dark:bg-orange-950/50 dark:text-orange-300',
        indicator: 'text-orange-600 dark:text-orange-400',
        dot: 'bg-orange-600'
    },
    'bg-amber-600': {
        button: 'border-amber-300 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-300',
        indicator: 'text-amber-600 dark:text-amber-400',
        dot: 'bg-amber-600'
    },
    'bg-yellow-600': {
        button: 'border-yellow-300 bg-yellow-50 text-yellow-700 dark:border-yellow-700 dark:bg-yellow-950/50 dark:text-yellow-300',
        indicator: 'text-yellow-600 dark:text-yellow-400',
        dot: 'bg-yellow-600'
    },
    'bg-lime-600': {
        button: 'border-lime-300 bg-lime-50 text-lime-700 dark:border-lime-700 dark:bg-lime-950/50 dark:text-lime-300',
        indicator: 'text-lime-600 dark:text-lime-400',
        dot: 'bg-lime-600'
    },
    'bg-green-600': {
        button: 'border-green-300 bg-green-50 text-green-700 dark:border-green-700 dark:bg-green-950/50 dark:text-green-300',
        indicator: 'text-green-600 dark:text-green-400',
        dot: 'bg-green-600'
    },
    'bg-emerald-600': {
        button: 'border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300',
        indicator: 'text-emerald-600 dark:text-emerald-400',
        dot: 'bg-emerald-600'
    },
    'bg-teal-600': {
        button: 'border-teal-300 bg-teal-50 text-teal-700 dark:border-teal-700 dark:bg-teal-950/50 dark:text-teal-300',
        indicator: 'text-teal-600 dark:text-teal-400',
        dot: 'bg-teal-600'
    },
    'bg-cyan-600': {
        button: 'border-cyan-300 bg-cyan-50 text-cyan-700 dark:border-cyan-700 dark:bg-cyan-950/50 dark:text-cyan-300',
        indicator: 'text-cyan-600 dark:text-cyan-400',
        dot: 'bg-cyan-600'
    },
    'bg-blue-600': {
        button: 'border-blue-300 bg-blue-50 text-blue-700 dark:border-blue-700 dark:bg-blue-950/50 dark:text-blue-300',
        indicator: 'text-blue-600 dark:text-blue-400',
        dot: 'bg-blue-600'
    },
    'bg-indigo-600': {
        button: 'border-indigo-300 bg-indigo-50 text-indigo-700 dark:border-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300',
        indicator: 'text-indigo-600 dark:text-indigo-400',
        dot: 'bg-indigo-600'
    },
    'bg-violet-600': {
        button: 'border-violet-300 bg-violet-50 text-violet-700 dark:border-violet-700 dark:bg-violet-950/50 dark:text-violet-300',
        indicator: 'text-violet-600 dark:text-violet-400',
        dot: 'bg-violet-600'
    },
    'bg-purple-600': {
        button: 'border-purple-300 bg-purple-50 text-purple-700 dark:border-purple-700 dark:bg-purple-950/50 dark:text-purple-300',
        indicator: 'text-purple-600 dark:text-purple-400',
        dot: 'bg-purple-600'
    },
    'bg-fuchsia-600': {
        button: 'border-fuchsia-300 bg-fuchsia-50 text-fuchsia-700 dark:border-fuchsia-700 dark:bg-fuchsia-950/50 dark:text-fuchsia-300',
        indicator: 'text-fuchsia-600 dark:text-fuchsia-400',
        dot: 'bg-fuchsia-600'
    },
    'bg-pink-600': {
        button: 'border-pink-300 bg-pink-50 text-pink-700 dark:border-pink-700 dark:bg-pink-950/50 dark:text-pink-300',
        indicator: 'text-pink-600 dark:text-pink-400',
        dot: 'bg-pink-600'
    },
    'bg-neutral-600': {
        button: 'border-neutral-300 bg-neutral-50 text-neutral-700 dark:border-neutral-700 dark:bg-neutral-950/50 dark:text-neutral-300',
        indicator: 'text-neutral-600 dark:text-neutral-400',
        dot: 'bg-neutral-600'
    }
};

export const getButtonActiveColor = (avatarColor) => {
    return BUTTON_ACTIVE_COLOR_MAP[avatarColor] || BUTTON_ACTIVE_COLOR_MAP['bg-violet-600'];
};
